import { useState, useEffect } from 'react';
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, orderBy, query, where, writeBatch, setDoc } from 'firebase/firestore';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { db, auth } from './firebase';
import * as XLSX from 'xlsx';

export default function MasterPanel() {
  const [tab, setTab] = useState('periods');
  const [periods, setPeriods] = useState([]);
  const [orders, setOrders] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState('');
  const [showOnlyActive, setShowOnlyActive] = useState(false);
  const [periodName, setPeriodName] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [uploads, setUploads] = useState({});
  const [users, setUsers] = useState([]);
  const [newUser, setNewUser] = useState({ name: '', email: '', password: '', role: 'employee' });
  const [durumlar, setDurumlar] = useState([]);
  const [newDurum, setNewDurum] = useState('');
  const [uploadingBayiler, setUploadingBayiler] = useState(false);
  const [uploadingMarkalar, setUploadingMarkalar] = useState(false);
  

  useEffect(() => { loadPeriods(); loadUploads(); loadUsers(); loadDurumlar(); }, []);

  const loadPeriods = async () => {
    const q = query(collection(db, 'periods'), orderBy('createdAt', 'desc'));
    const snap = await getDocs(q);
    setPeriods(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  };

  const loadUploads = async () => {
    const snap = await getDocs(collection(db, 'uploads'));
    const data = {};
    snap.docs.forEach(d => { data[d.id] = d.data(); });
    setUploads(data);
  };

  const loadUsers = async () => {
    const snap = await getDocs(collection(db, 'users'));
    setUsers(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  };

  const loadDurumlar = async () => {
    const snap = await getDocs(collection(db, 'durumlar'));
    const list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
    list.sort((a, b) => a.ad.localeCompare(b.ad, 'tr'));
    setDurumlar(list);
  };

  const loadOrders = async (periodId) => {
    if (!periodId) return;
    const q = query(collection(db, 'orders'), where('periodId', '==', periodId));
    const snap = await getDocs(q);
    setOrders(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  };

  const handlePeriodSelect = (e) => {
    const id = e.target.value;
    setSelectedPeriod(id);
    loadOrders(id);
  };

  // eslint-disable-next-line no-unused-vars
  const toggleStatus = async (p) => {
    const newStatus = p.status === 'active' ? 'closed' : 'active';
    await updateDoc(doc(db, 'periods', p.id), { status: newStatus });
    await loadPeriods();
  };

  const createPeriod = async (e) => {
    e.preventDefault();
    if (!periodName || !startDate || !endDate) return;
    if (new Date(endDate) < new Date(startDate)) { alert('Bitiş tarihi başlangıçtan önce olamaz!'); return; }
    setLoading(true);
    await addDoc(collection(db, 'periods'), {
      name: periodName, startDate, endDate, createdAt: new Date(), status: 'active'
    });
    setPeriodName(''); setStartDate(''); setEndDate('');
    await loadPeriods();
    setLoading(false);
  };

  const exportExcel = () => {
    if (orders.length === 0) { alert('Sipariş yok!'); return; }
    const period = periods.find(p => p.id === selectedPeriod);
    const rows = [];
    orders.forEach(o => {
      if (o.urunler && o.urunler.length > 0) {
        o.urunler.forEach(u => rows.push({
          'Satış Yöneticisi': o.satisYoneticisi || '',
          'Bayi Adı': o.bayiAdi || '',
          'Proje Adı': o.projeAdi || '',
          'Proje Durumu': o.projeDurumu || '',
          'Marka': u.marka || '',
          'Ürün Adı': u.urun || '',
          'Adet': u.adet || '',
          'Kasa': u.kasa ? 'Evet' : 'Hayır',
          'Teslimat Tarihi': o.teslimatTarihi || '',
          'Notlar': o.notlar || ''
        }));
      } else {
        rows.push({
          'Satış Yöneticisi': o.satisYoneticisi || '',
          'Bayi Adı': o.bayiAdi || '',
          'Proje Adı': o.projeAdi || '',
          'Proje Durumu': o.projeDurumu || '',
          'Marka': '', 'Ürün Adı': '', 'Adet': '', 'Kasa': '',
          'Teslimat Tarihi': o.teslimatTarihi || '',
          'Notlar': o.notlar || ''
        });
      }
    });
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, period?.name || 'Siparişler');
    XLSX.writeFile(wb, `${period?.name || 'siparisler'}.xlsx`);
  };

  const importBayiler = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploadingBayiler(true);
    const reader = new FileReader();
    reader.onload = async (evt) => {
      try {
        const wb = XLSX.read(evt.target.result, { type: 'binary' });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(ws, { header: 1 });
        const existing = await getDocs(collection(db, 'bayiler'));
        const batch = writeBatch(db);
        existing.docs.forEach(d => batch.delete(doc(db, 'bayiler', d.id)));
        await batch.commit();
        let count = 0;
        for (const row of rows.slice(1)) {
          if (row[0]) { await addDoc(collection(db, 'bayiler'), { ad: String(row[0]).trim() }); count++; }
        }
        await setDoc(doc(db, 'uploads', 'bayiler'), { fileName: file.name, uploadedAt: new Date().toLocaleString('tr-TR') });
        await loadUploads();
        setUploadingBayiler(false);
        alert(`✅ ${count} bayi başarıyla eklendi!`);
      } catch (err) { setUploadingBayiler(false); alert('❌ Hata: ' + err.message); }
    };
    reader.readAsBinaryString(file);
    e.target.value = '';
  };

  const importMarkalar = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploadingMarkalar(true);
    const reader = new FileReader();
    reader.onload = async (evt) => {
      try {
        const wb = XLSX.read(evt.target.result, { type: 'binary' });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(ws, { header: 1 });
        const existing = await getDocs(collection(db, 'markalar'));
const chunks = [];
for (let i = 0; i < existing.docs.length; i += 400) {
  chunks.push(existing.docs.slice(i, i + 400));
}
for (const chunk of chunks) {
  const batch = writeBatch(db);
  chunk.forEach(d => batch.delete(doc(db, 'markalar', d.id)));
  await batch.commit();
}
        let count = 0;
        for (const row of rows.slice(1)) {
          if (row[0] && row[1]) {
            const kasaGerektiriyor = row[2] && String(row[2]).toLowerCase().trim() === 'evet';
            await addDoc(collection(db, 'markalar'), {
              marka: String(row[0]).trim(),
              urun: String(row[1]).trim(),
              kasa: kasaGerektiriyor
            });
            count++;
          }
        }
        await setDoc(doc(db, 'uploads', 'markalar'), { fileName: file.name, uploadedAt: new Date().toLocaleString('tr-TR') });
        await loadUploads();
        setUploadingMarkalar(false);
        alert(`✅ ${count} ürün başarıyla eklendi!`);
      } catch (err) { setUploadingMarkalar(false); alert('❌ Hata: ' + err.message); }
    };
    reader.readAsBinaryString(file);
    e.target.value = '';
  };

  const deleteBayiler = async () => {
    if (!window.confirm('Tüm bayiler silinecek, emin misin?')) return;
    const existing = await getDocs(collection(db, 'bayiler'));
    const batch = writeBatch(db);
    existing.docs.forEach(d => batch.delete(doc(db, 'bayiler', d.id)));
    await batch.commit();
    await deleteDoc(doc(db, 'uploads', 'bayiler'));
    await loadUploads();
    alert('✅ Tüm bayiler silindi!');
  };

  const deleteMarkalar = async () => {
    if (!window.confirm('Tüm markalar ve ürünler silinecek, emin misin?')) return;
    const existing = await getDocs(collection(db, 'markalar'));
    const batch = writeBatch(db);
    existing.docs.forEach(d => batch.delete(doc(db, 'markalar', d.id)));
    await batch.commit();
    await deleteDoc(doc(db, 'uploads', 'markalar'));
    await loadUploads();
    alert('✅ Tüm markalar silindi!');
  };

  const addDurum = async (e) => {
    e.preventDefault();
    if (!newDurum.trim()) return;
    const existing = durumlar.find(d => d.ad.toLowerCase() === newDurum.trim().toLowerCase());
    if (existing) { alert('Bu durum zaten var!'); return; }
    await addDoc(collection(db, 'durumlar'), { ad: newDurum.trim() });
    setNewDurum('');
    await loadDurumlar();
  };

  const deleteDurum = async (id) => {
    if (!window.confirm('Bu durumu silmek istediğine emin misin?')) return;
    await deleteDoc(doc(db, 'durumlar', id));
    await loadDurumlar();
  };

  const addUser = async (e) => {
    e.preventDefault();
    if (!newUser.name || !newUser.email || !newUser.password) { alert('Tüm alanları doldur!'); return; }
    try {
      const cred = await createUserWithEmailAndPassword(auth, newUser.email, newUser.password);
      await setDoc(doc(db, 'users', cred.user.uid), { name: newUser.name, email: newUser.email, role: newUser.role, createdAt: new Date() });
      setNewUser({ name: '', email: '', password: '', role: 'employee' });
      await loadUsers();
      alert('✅ Kullanıcı eklendi!');
    } catch (err) { alert('❌ Hata: ' + err.message); }
  };

  const TABS = ['periods', 'orders', 'lists', 'users'];
  const TAB_LABELS = { periods: 'Dönemler', orders: 'Siparişler', lists: 'Listeler', users: 'Kullanıcılar' };
  const selectedPeriodObj = periods.find(p => p.id === selectedPeriod);

  return (
    <div>
      <div className="tab-row">
        {TABS.map(t => (
          <button key={t} className={`tab-btn ${tab === t ? 'active' : ''}`} onClick={() => setTab(t)}>
            {TAB_LABELS[t]}
          </button>
        ))}
      </div>

      {tab === 'periods' && (
        <div>
          <div className="card">
            <h2>Yeni Dönem Oluştur</h2>
            <form onSubmit={createPeriod}>
              <label className="label">Dönem Adı</label>
              <input className="input" placeholder="örn. A Siparişi" value={periodName} onChange={e => setPeriodName(e.target.value)} required />
              <label className="label">Başlangıç Tarihi</label>
              <input className="input" type="date" value={startDate} onChange={e => setStartDate(e.target.value)} required />
              <label className="label">Bitiş Tarihi</label>
              <input className="input" type="date" value={endDate} onChange={e => setEndDate(e.target.value)} required />
              <button className="btn-primary" type="submit" disabled={loading}>{loading ? 'Oluşturuluyor...' : 'Dönem Oluştur'}</button>
            </form>
          </div>
          <h3 className="section-title">Dönemler</h3>
          {periods.map(p => (
            <div key={p.id} className="card period-card" style={{ background: p.status === 'closed' ? '#f8f8f8' : 'white' }}>
              <div className="period-header">
                <div>
                  <div className="period-name" style={{ color: p.status === 'closed' ? '#999' : '#1a1a2e' }}>{p.name}</div>
                  <div className="period-date">{p.startDate} → {p.endDate}</div>
                </div>
                <div className="period-actions">
                  <span className={`badge ${p.status === 'active' ? 'badge-green' : 'badge-red'}`}>
                    {p.status === 'active' ? 'Aktif' : 'Kapalı'}
                  </span>
                  <button className={`btn-toggle ${p.status === 'active' ? 'btn-close' : 'btn-open'}`} onClick={() => toggleStatus(p)}>
  {p.status === 'active' ? 'Kapat' : 'Aç'}
</button>
                  <button className="btn-delete" onClick={async () => {
  if (!window.confirm(`"${p.name}" dönemi silinecek, emin misin?`)) return;
  await deleteDoc(doc(db, 'periods', p.id));
  await loadPeriods();
}}>Sil</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {tab === 'orders' && (
        <div>
          <div className="card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <h2 style={{ margin: 0 }}>Dönem Seç</h2>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 13, color: '#888' }}>Sadece aktif</span>
                <div onClick={() => { setShowOnlyActive(!showOnlyActive); setSelectedPeriod(''); setOrders([]); }}
                  style={{ width: 40, height: 22, borderRadius: 11, background: showOnlyActive ? '#4361ee' : '#ddd', cursor: 'pointer', position: 'relative', transition: 'background 0.2s' }}>
                  <div style={{ position: 'absolute', top: 3, left: showOnlyActive ? 20 : 3, width: 16, height: 16, borderRadius: '50%', background: 'white', transition: 'left 0.2s' }} />
                </div>
              </div>
            </div>
            <select className="input" value={selectedPeriod} onChange={handlePeriodSelect}>
              <option value="">Dönem seçiniz...</option>
              {periods.filter(p => showOnlyActive ? p.status === 'active' : true).map(p => (
                <option key={p.id} value={p.id}>
                  {p.name} ({p.startDate} → {p.endDate}) {p.status === 'active' ? '✓ Aktif' : '✗ Kapalı'}
                </option>
              ))}
            </select>
            {selectedPeriodObj && (
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12 }}>
                <span style={{ fontSize: 13, color: '#555' }}>{orders.length} sipariş</span>
                <button className="btn-export" onClick={exportExcel}>Excel İndir</button>
              </div>
            )}
          </div>

          {selectedPeriod && orders.map(o => (
            <div key={o.id} className="card order-card">
              <div className="order-header">
                <div className="order-title">{o.projeAdi}</div>
                <span className={`badge ${o.projeDurumu === 'Kesinleşti' ? 'badge-green' : o.projeDurumu === 'İptal' ? 'badge-red' : 'badge-yellow'}`}>{o.projeDurumu}</span>
              </div>
              <div className="order-detail">{o.satisYoneticisi} | {o.bayiAdi}</div>
              {o.urunler?.map((u, i) => (
                <div key={i} className="order-detail">
                  • {u.marka} — {u.urun} x{u.adet} {u.kasa ? '📦 Kasa' : ''}
                </div>
              ))}
              {o.teslimatTarihi && <div className="order-detail">Teslimat: {o.teslimatTarihi}</div>}
              {o.notlar && <div className="order-note">{o.notlar}</div>}
            </div>
          ))}

          {selectedPeriod && orders.length === 0 && (
            <div className="card"><p style={{ color: '#888', textAlign: 'center' }}>Bu dönemde sipariş yok</p></div>
          )}
        </div>
      )}

      {tab === 'lists' && (
        <div>
          <div className="card">
            <h2>Listeler</h2>
            <div className="upload-section-title">Bayi Listesi</div>
            {uploads.bayiler ? (
              <div className="upload-row">
                <div className="upload-info">
                  <span className="upload-icon">📎</span>
                  <div>
                    <div className="upload-name">{uploads.bayiler.fileName}</div>
                    <div className="upload-date">{uploads.bayiler.uploadedAt}</div>
                  </div>
                </div>
                <div className="upload-actions">
                  <label className="btn-secondary" style={{ cursor: 'pointer' }}>
                    Güncelle
                    <input type="file" accept=".xlsx,.xls" onChange={importBayiler} style={{ display: 'none' }} />
                  </label>
                  <button className="btn-delete" onClick={deleteBayiler}>Sil</button>
                </div>
              </div>
            ) : (
              <label>
                <div className="upload-drop-zone"
                  onDragOver={e => { e.preventDefault(); e.currentTarget.classList.add('drag-over'); }}
onDragLeave={e => e.currentTarget.classList.remove('drag-over')}                  onDrop={e => { e.preventDefault(); e.currentTarget.classList.remove('drag-over'); const f = e.dataTransfer.files[0]; if (f) importBayiler({ target: { files: [f], value: '' } }); }}>
                  <div className="upload-drop-icon">{uploadingBayiler ? '⏳' : '+'}</div>
                  <div className="upload-drop-text">{uploadingBayiler ? 'Yükleniyor, lütfen bekleyin...' : 'Bayi listesini buraya sürükle veya tıkla'}</div>
                  <div style={{ fontSize: 12, color: '#bbb', marginTop: 4 }}>.xlsx veya .xls</div>
                </div>
                <input type="file" accept=".xlsx,.xls" onChange={importBayiler} style={{ display: 'none' }} />
              </label>
            )}

            <div className="upload-section-title" style={{ marginTop: 20 }}>Marka & Ürün Listesi</div>
            <p className="hint">Excel formatı: 1. sütun = Marka, 2. sütun = Ürün Adı, 3. sütun = Kasa (Evet/Hayır)</p>
            {uploads.markalar ? (
              <div className="upload-row">
                <div className="upload-info">
                  <span className="upload-icon">📎</span>
                  <div>
                    <div className="upload-name">{uploads.markalar.fileName}</div>
                    <div className="upload-date">{uploads.markalar.uploadedAt}</div>
                  </div>
                </div>
                <div className="upload-actions">
                  <label className="btn-secondary" style={{ cursor: 'pointer' }}>
                    Güncelle
                    <input type="file" accept=".xlsx,.xls" onChange={importMarkalar} style={{ display: 'none' }} />
                  </label>
                  <button className="btn-delete" onClick={deleteMarkalar}>Sil</button>
                </div>
              </div>
            ) : (
              <label>
                <div className="upload-drop-zone"
                  onDragOver={e => { e.preventDefault(); e.currentTarget.classList.add('drag-over'); }}
                  onDragLeave={e => e.currentTarget.classList.remove('drag-over')}                   onDrop={e => { e.preventDefault(); e.currentTarget.classList.remove('drag-over'); const f = e.dataTransfer.files[0]; if (f) importMarkalar({ target: { files: [f], value: '' } }); }}>
                  <div className="upload-drop-icon">{uploadingMarkalar ? '⏳' : '+'}</div>
                  <div className="upload-drop-text">{uploadingMarkalar ? 'Yükleniyor, lütfen bekleyin...' : 'Marka/ürün listesini buraya sürükle veya tıkla'}</div>
                  <div style={{ fontSize: 12, color: '#bbb', marginTop: 4 }}>.xlsx veya .xls</div>
                </div>
                <input type="file" accept=".xlsx,.xls" onChange={importMarkalar} style={{ display: 'none' }} />
              </label>
            )}

            <div className="upload-section-title" style={{ marginTop: 20 }}>Proje Durumları</div>
            <form onSubmit={addDurum} style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
              <input className="input" placeholder="Yeni durum ekle..." value={newDurum} onChange={e => setNewDurum(e.target.value)} style={{ marginBottom: 0 }} />
              <button className="btn-primary" type="submit" style={{ whiteSpace: 'nowrap' }}>Ekle</button>
            </form>
            {durumlar.length === 0 && <p style={{ color: '#aaa', fontSize: 13 }}>Henüz durum eklenmedi</p>}
            {durumlar.map(d => (
              <div key={d.id} className="list-row">
                <span>{d.ad}</span>
                <button className="btn-delete" onClick={() => deleteDurum(d.id)}>Sil</button>
              </div>
            ))}
          </div>
        </div>
      )}

      {tab === 'users' && (
        <div>
          <div className="card">
            <h2>Yeni Kullanıcı Ekle</h2>
            <form onSubmit={addUser}>
              <label className="label">Rol</label>
              <select className="input" value={newUser.role} onChange={e => setNewUser(u => ({ ...u, role: e.target.value }))} style={{ marginBottom: 12 }}>
                <option value="employee">Çalışan</option>
                <option value="master">Master</option>
              </select>
              <label className="label">Ad Soyad</label>
              <input className="input" placeholder="Ad Soyad" value={newUser.name} onChange={e => setNewUser(u => ({ ...u, name: e.target.value }))} required />
              <label className="label">Email</label>
              <input className="input" type="email" placeholder="Email" value={newUser.email} onChange={e => setNewUser(u => ({ ...u, email: e.target.value }))} required />
              <label className="label">Şifre</label>
              <input className="input" type="password" placeholder="Şifre" value={newUser.password} onChange={e => setNewUser(u => ({ ...u, password: e.target.value }))} required />
              <button className="btn-primary" type="submit">Kullanıcı Ekle</button>
            </form>
          </div>
          <h3 className="section-title">Kullanıcılar</h3>
          {users.map(u => (
  <div key={u.id} className="card" style={{ padding: '1rem 1.25rem' }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div>
        <div className="period-name">{u.name}</div>
        <div className="period-date">{u.email}</div>
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <span className={`badge ${u.role === 'master' ? 'badge-yellow' : 'badge-green'}`}>
          {u.role === 'master' ? 'Master' : 'Çalışan'}
        </span>
        <button className="btn-secondary" onClick={async () => {
          const newRole = u.role === 'master' ? 'employee' : 'master';
          await updateDoc(doc(db, 'users', u.id), { role: newRole });
          await loadUsers();
        }}>
          {u.role === 'master' ? 'Çalışan Yap' : 'Master Yap'}
        </button>
        <button className="btn-secondary" onClick={async () => {
  const { sendPasswordResetEmail } = await import('firebase/auth');
  await sendPasswordResetEmail(auth, u.email);
  alert(`${u.email} adresine şifre sıfırlama emaili gönderildi!`);
}}>Şifre Sıfırla</button>
<button className="btn-delete" onClick={async () => {
          if (!window.confirm(`${u.name} silinecek, emin misin?`)) return;
          await deleteDoc(doc(db, 'users', u.id));
          await loadUsers();
        }}>Sil</button>
      </div>
    </div>
  </div>
))}
        </div>
      )}
    </div>
  );
}